// מחולל סרטון הכתרה 9:16 לשיתוף ברשתות (Canvas + MediaRecorder)

const W = 720;
const H = 1280;
const DURATION = 6500;

const clamp01 = (v) => Math.max(0, Math.min(1, v));
const easeOutBack = (t) => { const c = 1.70158; const x = t - 1; return 1 + (c + 1) * x * x * x + c * x * x; };
const fadeIn = (t, start, dur = 0.5) => clamp01((t - start) / dur);

function fitFont(ctx, text, maxWidth, baseSize, weight = 'bold') {
  let size = baseSize;
  do {
    ctx.font = `${weight} ${size}px "Segoe UI", "Heebo", Arial, sans-serif`;
    if (ctx.measureText(text).width <= maxWidth) break;
    size -= 2;
  } while (size > 18);
  return size;
}

function makeConfetti(count = 90) {
  const colors = ['#fbbf24', '#34d399', '#60a5fa', '#f472b6', '#f87171', '#facc15'];
  return Array.from({ length: count }, (_, i) => ({
    x: (i * 137.5) % W,
    speed: 90 + (i * 53) % 160,
    size: 7 + (i * 31) % 9,
    color: colors[i % colors.length],
    phase: (i * 211) % (H + 60),
    rot: (i * 47) % 360,
    rotSpeed: 60 + (i * 29) % 220,
  }));
}

function drawFrame(ctx, t, data, confetti) {
  const { tournamentName, dateStr, champName, runnerName, consChamp } = data;

  // רקע
  const grad = ctx.createLinearGradient(0, 0, 0, H);
  grad.addColorStop(0, '#020617');
  grad.addColorStop(0.55, '#07131c');
  grad.addColorStop(1, '#0b2b20');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  // קווי מגרש עדינים
  ctx.strokeStyle = 'rgba(52, 211, 153, 0.10)';
  ctx.lineWidth = 3;
  ctx.strokeRect(60, 120, W - 120, H - 320);
  ctx.beginPath();
  ctx.moveTo(60, H / 2 - 40);
  ctx.lineTo(W - 60, H / 2 - 40);
  ctx.stroke();

  ctx.textAlign = 'center';
  ctx.direction = 'rtl';

  // קונפטי (מאחורי הטקסט) - מתחיל אחרי חשיפת האלוף
  if (t > 2.4) {
    const ct = t - 2.4;
    confetti.forEach((p) => {
      const y = ((p.phase + ct * p.speed) % (H + 60)) - 60;
      ctx.save();
      ctx.translate(p.x, y);
      ctx.rotate(((p.rot + ct * p.rotSpeed) * Math.PI) / 180);
      ctx.globalAlpha = 0.85;
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size * 0.8, p.size, p.size * 1.6);
      ctx.restore();
    });
    ctx.globalAlpha = 1;
  }

  // שם הטורניר
  const a1 = fadeIn(t, 0.15, 0.6);
  if (a1 > 0) {
    ctx.globalAlpha = a1;
    ctx.fillStyle = '#e2e8f0';
    const s = fitFont(ctx, tournamentName, W - 100, 46, '800');
    ctx.font = `800 ${s}px "Segoe UI", "Heebo", Arial, sans-serif`;
    ctx.fillText(tournamentName, W / 2, 230 + (1 - a1) * 30);
    if (dateStr) {
      ctx.fillStyle = '#64748b';
      ctx.font = '500 26px "Segoe UI", "Heebo", Arial, sans-serif';
      ctx.fillText(dateStr, W / 2, 278 + (1 - a1) * 30);
    }
    ctx.globalAlpha = 1;
  }

  // גביע
  const a2 = clamp01((t - 1.0) / 0.7);
  if (a2 > 0) {
    const scale = easeOutBack(a2);
    ctx.save();
    ctx.translate(W / 2, 470);
    ctx.scale(scale, scale);
    ctx.font = '150px "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif';
    ctx.fillText('🏆', 0, 50);
    ctx.restore();
  }

  // אלוף הטורניר
  const a3 = fadeIn(t, 2.0, 0.5);
  if (a3 > 0) {
    ctx.globalAlpha = a3;
    ctx.fillStyle = '#94a3b8';
    ctx.font = '600 34px "Segoe UI", "Heebo", Arial, sans-serif';
    ctx.fillText('אלוף הטורניר', W / 2, 640);
    ctx.globalAlpha = 1;
  }

  // שם האלוף — זהב עם הילה נושמת
  const a4 = clamp01((t - 2.5) / 0.6);
  if (a4 > 0) {
    const scale = 0.7 + 0.3 * easeOutBack(a4);
    ctx.save();
    ctx.translate(W / 2, 745);
    ctx.scale(scale, scale);
    ctx.globalAlpha = a4;
    ctx.shadowColor = '#fbbf24';
    ctx.shadowBlur = 26 + Math.sin(t * 4) * 12;
    ctx.fillStyle = '#fbbf24';
    const s = fitFont(ctx, champName, W - 120, 78, '900');
    ctx.font = `900 ${s}px "Segoe UI", "Heebo", Arial, sans-serif`;
    ctx.fillText(champName, 0, 0);
    ctx.restore();
  }

  // סגן אלוף + אלוף תנחומים
  const a5 = fadeIn(t, 4.2, 0.5);
  if (a5 > 0 && runnerName) {
    ctx.globalAlpha = a5;
    ctx.fillStyle = '#cbd5e1';
    ctx.font = '600 32px "Segoe UI", "Heebo", Arial, sans-serif';
    ctx.fillText(`🥈 סגן אלוף: ${runnerName}`, W / 2, 860);
    ctx.globalAlpha = 1;
  }
  const a6 = fadeIn(t, 4.6, 0.5);
  if (a6 > 0 && consChamp) {
    ctx.globalAlpha = a6;
    ctx.fillStyle = '#cbd5e1';
    ctx.font = '600 30px "Segoe UI", "Heebo", Arial, sans-serif';
    ctx.fillText(`🎗️ אלוף התנחומים: ${consChamp}`, W / 2, 915);
    ctx.globalAlpha = 1;
  }

  // מיתוג תחתון
  ctx.fillStyle = '#10b981';
  ctx.font = '800 34px "Segoe UI", Arial, sans-serif';
  ctx.direction = 'ltr';
  ctx.fillText('TENNIS PRO ISRAEL', W / 2, H - 130);
  ctx.fillStyle = '#475569';
  ctx.font = '500 24px "Segoe UI", Arial, sans-serif';
  ctx.fillText('tennisproisrael.co.il', W / 2, H - 90);
  ctx.direction = 'rtl';
}

function pickMime() {
  const candidates = ['video/mp4', 'video/webm;codecs=vp9', 'video/webm'];
  return candidates.find((m) => window.MediaRecorder && MediaRecorder.isTypeSupported(m)) || '';
}

export async function generateChampionVideo(data, onProgress) {
  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');
  const confetti = makeConfetti();

  const mime = pickMime();
  if (!mime) throw new Error('הדפדפן לא תומך בהקלטת וידאו');

  const stream = canvas.captureStream(30);
  const recorder = new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: 5_000_000 });
  const chunks = [];
  recorder.ondataavailable = (e) => { if (e.data.size) chunks.push(e.data); };

  const done = new Promise((resolve) => { recorder.onstop = () => resolve(new Blob(chunks, { type: mime.split(';')[0] })); });

  drawFrame(ctx, 0, data, confetti);
  recorder.start(200);
  const start = performance.now();

  await new Promise((resolve) => {
    const tick = () => {
      const elapsed = performance.now() - start;
      drawFrame(ctx, elapsed / 1000, data, confetti);
      if (onProgress) onProgress(Math.min(99, Math.round((elapsed / DURATION) * 100)));
      if (elapsed < DURATION) requestAnimationFrame(tick);
      else resolve();
    };
    requestAnimationFrame(tick);
  });

  recorder.stop();
  const blob = await done;
  if (onProgress) onProgress(100);
  return blob;
}

export async function shareOrDownloadVideo(blob, { filename = 'champion.webm', title = 'טניס פרו ישראל' } = {}) {
  const ext = blob.type.includes('mp4') ? 'mp4' : 'webm';
  const name = filename.replace(/\.(mp4|webm)$/i, '') + '.' + ext;
  const file = new File([blob], name, { type: blob.type });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title });
      return 'shared';
    } catch (e) {
      if (e.name === 'AbortError') return 'cancelled';
    }
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = name;
  link.href = url;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return 'downloaded';
}
